export default __webpack_public_path__ + "static/media/poc.32bcf76b.pdf";